import { MarketStatus } from '@ps/isp-web-services-types';
import produce from 'immer';

import type { MarketPollingData } from '@swf/sports/types/market';
import updateMarket from '@swf/sports/utils/updateMarket';

import { defaultState } from './defaultState';
import type { CompetitionEventsTemplatesView } from './types';

type State = typeof defaultState;

export const reducers = {
  'cms/update': () => defaultState,
  clear: (): State => produce(defaultState, (draft) => draft),
  competitionEventsRequested: (
    state: State,
    { isBackgroundLoading = false }: { isBackgroundLoading?: boolean } = {}
  ): State => ({
    ...state,
    isLoading: !isBackgroundLoading
  }),
  competitionEventsDataLoadFailed: (state: State, payload: number): State => ({
    ...state,
    isLoading: false,
    hasPreloaded: true,
    errorCode: payload
  }),
  competitionEventsDataLoadSuccess: (
    state: State,
    payload: CompetitionEventsTemplatesView
  ): State => ({
    ...state,
    isLoading: false,
    hasPreloaded: true,
    ...payload
  }),
  marketsUpdated: (state: State, { data: marketUpdates, closed }: MarketPollingData) =>
    produce(state, (draft) => {
      Object.values(draft.markets).forEach((market) => {
        if (!market) return;

        if (closed.includes(market.marketId)) {
          market.marketStatus = MarketStatus.CLOSED;
          return;
        }

        const marketUpdate = marketUpdates[market.marketId];

        if (marketUpdate) updateMarket(market, marketUpdate);
      });

      return draft;
    })
};
